var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResearchgateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Research Gate",
    role: "img",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 76.8,
    ry: 76.8,
    fill: "#00d0af"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#feffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m271 383c-15-4-23-10-36-26-9-12-26-39-35-53l-6-11h-24v34c1 43 0 42 19 45l10 1v8h-80v-4c0-4 1-4 9-6 10-2 14-5 15-14 1-4 1-31 1-79 0-70-1-72-3-77-3-5-7-7-18-8-4-1-5-1-5-5v-4l43-1c55-1 65 0 81 11 15 10 22 24 20 43-1 21-17 42-37 50-4 1-7 3-7 3 0 2 17 28 28 43 15 21 27 32 36 37 4 2 9 3 10 3 3 0 3 1 3 4s-1 5-2 5c-5 2-19 2-26 0zm-57-109c14-7 22-18 23-35 1-13-2-22-10-30-9-10-25-14-48-12l-10 1v39c0 36 0 40 2 40 1 0 9 1 18 0 14 0 17-1 24-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321 228c-25-4-34-20-32-61 1-21 3-30 11-38 7-7 13-9 25-10 13-1 21 2 29 8 5 4 9 10 9 13 0 1-3 2-6 4l-6 3-3-3c-5-6-9-9-14-11-10-3-20 2-25 11-3 5-3 6-3 29 0 22 0 25 3 29 4 7 12 11 21 10 13-1 20-10 20-24v-7h-20v-13h36v15c0 12-1 16-3 22-6 15-23 24-42 22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchgateLogo);
export default __webpack_public_path__ + "static/media/researchgateLogo.18cff2a057fee91bf7fd3d9393fea4c9.svg";
export { ForwardRef as ReactComponent };